import React from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
// eslint-disable-next-line max-len
import { handleUnavailableFeaturePopupError } from 'containers/dashboard/features/unavailable-feature-popup/store/actions'

import { PATH_APPLICATIONS } from 'config/paths'
import { IMainItem, IItem } from 'config/types'
import { getAppIdCookie } from 'utils/token'

import { SetOpenMenuAction } from 'layouts/dashboard/store/actions'

import { IconRender } from '../navigation/IconRender'

import './MenuItem.scss'

interface IMenuItem {
    menuItem: IMainItem | IItem
}

const MenuItem = ({ menuItem }: IMenuItem): React.ReactElement => {
    const { t } = useTranslation(['menu', 'toast'])

    const dispatch = useDispatch()
    const history = useHistory()
    const { pathname } = useLocation()
    const appId = getAppIdCookie()

    const pushOnPage = (url: string) => {
        if (!url.includes('feature')) {
            history.push(url)
            return null
        }

        if (
            typeof menuItem.isAvailable === 'boolean' &&
            !menuItem.isAvailable &&
            url.includes('feature')
        ) {
            dispatch(
                handleUnavailableFeaturePopupError({ message: 'Show popup' }),
            )
        } else {
            history.push(url)
        }

        return null
    }

    const chooseCategory = () => {
        const { path } = menuItem
        // eslint-disable-next-line dot-notation
        if (!menuItem['includes'] || menuItem['includes'].length === 0) {
            dispatch(
                SetOpenMenuAction({
                    isOpen: false,
                }),
            )
        }
        pushOnPage(path)
    }

    return (
        <li
            className={classNames('menu-item__wrapper', {
                'preview-item': menuItem.icon === 'loader',
            })}
            key={menuItem.key}
        >
            {menuItem.comingSoon ? (
                <div className='menu-item__soon'>
                    <p className='menu-item__soon-text'>
                        {t('menu:comingSoon')}
                    </p>
                </div>
            ) : null}
            <div className='menu-item' id={menuItem.type ?? menuItem.name}>
                <button
                    type='button'
                    className={classNames('menu-item__button', {
                        'menu-item__button--active': pathname.includes(
                            menuItem.icon,
                        ),
                    })}
                    onClick={() => {
                        if (appId) {
                            chooseCategory()
                        } else {
                            history.push(PATH_APPLICATIONS.root)
                            toast.error(t('toast:chooseAppError'))
                        }
                    }}
                >
                    <div
                        className={`${
                            pathname.includes(menuItem.icon)
                                ? 'menu-item__icon--active'
                                : 'menu-item__icon'
                        }`}
                    >
                        <IconRender
                            iconName={menuItem.icon}
                            isActive={pathname.includes(menuItem.icon)}
                        />
                    </div>
                    <div className='menu-item__name'>
                        {t(`menu:${menuItem.name}`)}
                    </div>
                </button>
            </div>
        </li>
    )
}

export default MenuItem
